<template>
  <div class="creditCardItem">
    <div class="card mt-2" v-for="(item, i) in itens" :key="i">
      <div class="ml-2">
        <div class="card d-flex flex-column m-2">
          <div class="p-1 m-2">
            <strong>Número</strong> <br />
            <span v-if="item.cartaoOrigem === 'CARTAO_COMPRA'"
              >{{ formatNumeroCartao(item.numeroCartao) }}
            </span>

            <span v-else
              >{{ item.primeirosDigitos }}&nbsp;XXXX&nbsp;XXXX&nbsp;{{
                regexNumber(item.ultimosDigitos)
              }}
            </span>
          </div>
          <div class="p-1 d-flex justify-content-between">
            <div class="m-2">
              <strong>Validade</strong><br />
              <span>
                {{ formatVencimentoCartao(item.mesValidade) }}
              </span>
            </div>
            <div class="m-2">
              <img :src="icons[item.bandeira]" alt="bandeira" width="73" />
            </div>
          </div>
        </div>

        <div
          class="card d-flex justify-content-between m-2"
          v-if="item.cartaoOrigem === 'CARTAO_COMPRA'"
        >
          <div class="m-1" v-if="item.statusCartaoAplicativo">
            <strong>Aplicativo:</strong>
            <span
              class="ml-1"
              v-if="
                item.statusCartaoAplicativo.status ==
                'CARTAO_APLICATIVO_DOCUMENTACAO_PENDENTE'
              "
              >Aguardando documentação</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoAplicativo.status ==
                'CARTAO_APLICATIVO_DOCUMENTACAO_APROVADA'
              "
              >Documentação aprovada</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoAplicativo.status ==
                'CARTAO_APLICATIVO_DOCUMENTACAO_RECUSADA'
              "
              >Documentação recusada</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoAplicativo.status ==
                'CARTAO_APLICATIVO_DESBLOQUEADO'
              "
              >Saldo Liberado</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoAplicativo.status ==
                'CARTAO_APLICATIVO_BLOQUEADO'
              "
              >Aplicativo bloqueado</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoAplicativo.status == 'CARTAO_APLICATIVO_ATIVO'
              "
              >Aplicativo ativo</span
            >
          </div>
          <div class="m-1" v-if="item.statusCartaoFisico">
            <strong>Cartão físico:</strong>
            <span
              class="ml-1"
              v-if="
                item.statusCartaoFisico.status == 'CARTAO_FISICO_SOLICITADO'
              "
              >Cartão solicitado</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoFisico.status ==
                'CARTAO_FISICO_ENVIADO_PARA_IMPRESSAO'
              "
              >Enviado para impressão</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoFisico.status ==
                'CARTAO_FISICO_AGUARDANDO_DESBLOQUEIO'
              "
              >Aguardando desbloqueio</span
            >
            <span
              class="ml-1"
              v-if="
                item.statusCartaoFisico.status == 'CARTAO_FISICO_DESBLOQUEADO'
              "
              >Cartão desbloqueado</span
            >
            <span
              class="ml-1"
              v-if="item.statusCartaoFisico.status == 'CARTAO_FISICO_BLOQUEADO'"
              >Cartão bloqueado</span
            >
            <span
              class="ml-1"
              v-if="item.statusCartaoFisico.status == 'CARTAO_FISICO_ATIVO'"
              >Cartão ativo</span
            >
          </div>
        </div>

        <div class="card d-flex flex-column m-2" v-if="novaSenha">
          <div class="p-1 m-2 text-center">
            <strong>Nova senha</strong> <br />
            <h3>{{ novaSenha }}</h3>
          </div>
        </div>

        <div class="p-1 d-flex justify-content-end m-2 text-center">
          <div
            class="m-1"
            v-if="item.cartaoOrigem !== 'CARTAO_COMPRA'"
            @click="remover(item)"
          >
            <img :src="icons['remove']" alt="bandeira" width="25" />
            <span class="ml-1">remover</span>
          </div>

          <div
            class="m-1"
            v-if="
              item.statusCartaoFisico.status ===
              'CARTAO_FISICO_AGUARDANDO_DESBLOQUEIO'
            "
            @click="desbloquearCartao(item.statusCartaoFisico)"
          >
            <img :src="icons['password']" alt="bandeira" width="25" />
            <span class="ml-1">Desbloquear</span>
            <img />
          </div>

          <div class="m-1" @click="gerarSenha(item.statusCartaoFisico.contaId)">
            <img :src="icons['password']" alt="bandeira" width="25" />
            <span class="ml-1">Gerar senha</span>

            <img />
          </div>

          <div class="m-1" @click="handleClick(item)" v-if="objItem">
            <img :src="icons['check']" alt="bandeira" width="25" />
            <span class="ml-1">selecionar</span>
          </div>
        </div>
      </div>
    </div>
    <Success :dados="sucesso"></Success>
  </div>
</template>

<script>
import icons from "@/shared/components/SvgIcon.js";
import Success from "@/components/Success.vue";

import { ApiCartoesService } from "@/service/carteira-digital/ApiCartoesService.js";
const cartoesService = new ApiCartoesService();

export default {
  name: "CreditCardItem",
  emits: ["loadCartoes"],
  props: {
    itens: Array,
    objItem: Object,
  },
  components: {
    Success,
  },
  data() {
    return {
      icons,
      sucesso: {
        type: "NONE",
      },
      novaSenha: "",
    };
  },
  created() {},
  methods: {
    formatVencimentoCartao(mesVal) {
      let validade = `${mesVal.substring(0, 2)}/${mesVal.substring(2, 4)}`;

      return validade;
    },
    formatNumeroCartao(cartao) {
      let nuCartao = `${cartao.substring(0, 4)} ${cartao.substring(
        4,
        8
      )} ${cartao.substring(8, 12)} ${cartao.substring(12, 16)}`;

      return nuCartao;
    },
    handleClick(item) {
      if (this.objItem) {
        this.$router.push({
          name: "PagamentosDetalhes",
          params: {
            objItem: this.objItem,
            objCartao: item,
            objMetodo: "CARTAO_CREDITO",
          },
        });
      }
    },
    remover(item) {
      this.sucesso.type = "AGUARDE";
      this.sucesso.mensagem = "Aguarde, estamos processando sua solicitação";

      cartoesService
        .removerCartao(item.codigoCartao)
        .then(() => {
          this.sucesso.type = "SUCESSO";
          this.sucesso.mensagem = "Cartão removido com sucesso.";
          this.$emit("loadCartoes");
        })
        .catch((error) => {
          this.sucesso.type = "ERRO";
          this.sucesso.mensagem = error.response
            ? error.response.data.title
            : "Serviço indisponível.";
          this.flCadastrarEndereco = true;
        });
    },

    desbloquearCartao(statusCartaoFisico) {
      this.sucesso.type = "AGUARDE";
      this.sucesso.mensagem = "Aguarde, estamos processando sua solicitação";

      let dadosCartao = statusCartaoFisico;
      dadosCartao.status = "CARTAO_FISICO_DESBLOQUEADO";
      cartoesService
        .desbloquearCartaoFisico(dadosCartao)
        .then(() => {
          this.sucesso.type = "SUCESSO";
          this.sucesso.mensagem = "Cartão desbloqueado com sucesso.";
          this.$emit("loadCartoes");
        })
        .catch((error) => {
          this.sucesso.type = "ERRO";
          this.sucesso.mensagem = error.response
            ? error.response.data.title
            : "Serviço indisponível.";
          this.flCadastrarEndereco = true;
        });
    },
    gerarSenha(contaId) {
      cartoesService
        .gerarSenhaCartaoCompras(contaId)
        .then((res) => {
          this.novaSenha = res;
          this.sucesso.type = "SUCESSO";
          this.sucesso.mensagem = "Senha criada com sucesso.";
        })
        .catch((error) => {
          this.sucesso.type = "ERRO";
          this.sucesso.mensagem = error.response
            ? error.response.data.title
            : "Serviço indisponível.";
          this.flCadastrarEndereco = true;
        });
    },
    regexNumber(n) {
      return n.replace(/[^0-9]/gm, "");
    },
  },
};
</script>
<style scoped lang="scss">
.card {
  border-radius: 10px;
}
</style>
